export class StatusQueueRequest{
    public idStatusQueue: number;

    public idQueue: number;

    public idHealthUnit: number;

    public idEpisode: number;

    public conclusionNote: string;

    public idRoom:number;

    public idUser:number;
}